import {ModoDeVenda} from './wizard-state.model';

export type TipoDeLojaWizard = 'CARDAPIO' | 'CATALOGO';

export class WizardModosVenda {
  static normalize(modos: ModoDeVenda[]): ModoDeVenda[] {
    const unicos = Array.from(new Set(modos || []));
    const modosOperacionais = unicos.filter(modo => modo !== 'catalogo');

    return modosOperacionais.length ? modosOperacionais : unicos.filter(modo => modo === 'catalogo');
  }

  static obtenhaTipoDeLoja(modos: ModoDeVenda[]): TipoDeLojaWizard {
    const normalizados = this.normalize(modos);
    return normalizados.length === 1 && normalizados[0] === 'catalogo' ? 'CATALOGO' : 'CARDAPIO';
  }

  static monteFormasDeEntrega(modos: ModoDeVenda[], formasAtuais: any[] = []): any[] {
    const normalizados = this.normalize(modos);
    const retiradaAtual = this.obtenhaFormaAtual(formasAtuais, 1);
    const entregaAtual = this.obtenhaFormaAtual(formasAtuais, 2);
    const permiteRetirada = normalizados.includes('retirada') || normalizados.includes('mesa');

    const retirada = Object.assign({
      formaDeEntrega: {id: 1},
      nome: 'Retirar',
      valorMinimoPedido: 0,
      possuiDesconto: false,
      descontoPercentual: 0,
      possuiDescontoComerNoLocal: false,
      descontoPercentualComerNoLocal: 0,
      raiosDeCobranca: [],
      zonasDeEntrega: []
    }, retiradaAtual, {
      formaDeEntrega: Object.assign({}, retiradaAtual.formaDeEntrega, {id: 1}),
      nome: 'Retirar',
      ativa: permiteRetirada,
      permiteComerNoLocal: normalizados.includes('mesa')
    });

    const entrega = Object.assign({
      formaDeEntrega: {id: 2},
      nome: 'Receber em casa',
      valorMinimoPedido: 0,
      valorMinimoFreteGratis: 0,
      tipoDeCobranca: 'fixo',
      taxaFixa: 0,
      exibirTelaBusca: true,
      possuiDesconto: false,
      descontoPercentual: 0,
      raiosDeCobranca: [],
      zonasDeEntrega: []
    }, entregaAtual, {
      formaDeEntrega: Object.assign({}, entregaAtual.formaDeEntrega, {id: 2}),
      nome: 'Receber em casa',
      ativa: normalizados.includes('delivery')
    });

    return [retirada, entrega];
  }

  private static obtenhaFormaAtual(formasAtuais: any[], idForma: number): any {
    return (formasAtuais || []).find(forma => Number(forma?.formaDeEntrega?.id) === idForma) || {};
  }
}
